import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

const About = () => {
  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Seo
        title="About CardCombiner – Built by Axel at Lumbridge Holding"
        description="Learn who builds CardCombiner: an independent developer in Stockholm making a free, private image grid tool for trading-card sellers and marketplace listings."
        path="/about"
      />
      <Navbar />
      <div className="max-w-4xl mx-auto p-4 md:p-8 flex-grow">
        <div className="bg-white p-6 md:p-8 rounded-[16px] md:rounded-[24px] shadow-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-[#6B4EE6]">About CardCombiner</h1>
          
          <div className="space-y-6">
            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Who We Are
              </h2>
              <p className="text-gray-700 leading-relaxed">
                CardCombiner is developed and maintained by Axel at Lumbridge Holding,
                a small independent software company based in Stockholm, Sweden. The
                project started in 2024 after I spent one too many evenings manually
                stitching together photos of Pokémon and sports cards for online
                listings. What began as a personal utility grew into a free public
                tool that now helps trading-card sellers, marketplace shops, and
                everyday users combine images quickly and privately.
              </p>
              <p className="text-gray-700 leading-relaxed mt-3">
                I write every line of code, design every page, and answer every
                support email personally. There is no anonymous team behind a brand
                name — just one developer who cares about building tools that
                respect your time and your data.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Our Mission
              </h2>
              <p className="text-gray-700 leading-relaxed">
                CardCombiner was created with a simple mission: to make combining multiple images 
                into a single organized image as easy as possible. Whether you're creating 
                collages, comparing products, documenting collectibles like trading cards, or 
                showcasing items for sale, we've built a tool that does the job quickly and 
                efficiently, right in your browser.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                How It Works
              </h2>
              <p className="text-gray-700 leading-relaxed">
                CardCombiner uses advanced browser-based image processing to combine your images 
                without uploading them to any server. This means your images stay private and the 
                process is lightning fast. We automatically arrange your images in an optimal grid 
                layout and allow you to download the result in your preferred format.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Why Choose CardCombiner
              </h2>
              <ul className="list-disc ml-5 space-y-3">
                <li className="text-gray-700">
                  <span className="font-medium">Privacy-focused</span>: Your images never leave your device
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Fast processing</span>: No need to wait for uploads or server processing
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Simple interface</span>: No complicated options or settings
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Multiple formats</span>: Download in JPEG, PNG, or WebP format
                </li>
                <li className="text-gray-700">
                  <span className="font-medium">Batch mode</span>: Create multiple collages at once for large collections
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Our Commitment
              </h2>
              <p className="text-gray-700 leading-relaxed">
                We are committed to keeping CardCombiner free, fast, and private. We continuously 
                improve the tool based on user feedback and strive to provide the best image 
                combining experience on the web. If you have suggestions or questions, don't 
                hesitate to reach out through our contact page.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Contact &amp; Company Info
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Operated by <strong>Lumbridge Holding</strong> — Stockholm, Sweden.
                <br />
                Founder &amp; developer: <strong>Axel</strong>
                <br />
                Email:{" "}
                <a
                  href="mailto:axel@lumbridgeholding.se"
                  className="text-[#6B4EE6] underline hover:no-underline"
                >
                  axel@lumbridgeholding.se
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
